'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Badge;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Label = require('../typography/Label');

var _Label2 = _interopRequireDefault(_Label);

require('./badge.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Badge(props) {
  var size = props.size,
      type = props.type,
      label = props.label,
      outlined = props.outlined;
  var badgeOutlined = outlined ? type + '-outlined' : '';
  return _react2.default.createElement('span', {
    className: 'badge-input ' + type + ' badge-' + size + ' ' + badgeOutlined
  }, _react2.default.createElement(_Label2.default, {
    label: label
  }));
}